function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.423288mm",
    height: "16.423288mm",
    viewBox: "0 0 16.423288 16.423288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0.01161994,-5.7730377e-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect991-2",
    style: {
      fontVariationSettings: "normal",
      vectorEffect: "none",
      fill: "#fcb131",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    },
    d: "M 34.398438,0 V 62.072266 H 62.072266 V 0 Z m 5.078124,6.9589844 H 56.996094 V 55.109375 c -5.83948,-4e-6 -11.680052,0 -17.519532,0 0,-16.050361 -3e-6,-32.100027 0,-48.1503906 z",
    transform: "matrix(0.26458333,0,0,0.26458333,-0.01161994,5.7730377e-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect991-1",
    style: {
      fill: "#fcb131",
      stroke: "#000000",
      strokeWidth: 0,
      paintOrder: "stroke markers fill"
    },
    d: "M 0.05859375,0.01953125 V 15.021484 H 27.736328 V 0.01953125 Z M 6.7109375,4.9648438 H 21.083984 V 10.076172 H 6.7109375 Z",
    transform: "matrix(0.26458333,0,0,0.26458333,-0.01161994,5.7730377e-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect991-8-1",
    style: {
      fill: "#fcb131",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0,
      paintOrder: "stroke markers fill"
    },
    d: "M 0,33.353516 V 62.023438 H 27.742188 V 33.353516 Z m 6.1582031,5.550781 H 21.583984 v 6.791015 H 6.1582031 Z m 0,10.791015 H 21.583984 v 6.777344 H 6.1582031 Z",
    transform: "matrix(0.26458333,0,0,0.26458333,-0.01161994,5.7730377e-4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.7b22b193.svg";
export { ForwardRef as ReactComponent };